import { DataTable, Dialog, Loader } from "@/components";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui";
import useOccupantsDialog from "./useOccupantsDialog";
import { OccupantsDialogProps } from "./types";
import { TabsContent } from "@radix-ui/react-tabs";
import { CURRENT, HISTORY, occupantsTabs } from "../consts";

const OccupantsDialog = ({
  open,
  setOpen,
  selectedRow,
}: OccupantsDialogProps) => {
  const { activeTab, onTabChange, columns, isLoading, usersGridData } = useOccupantsDialog({ selectedRow });
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={<div className="text-2xl font-bold text-primary">
          {"Current Occupants"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      contentClassName="lg:!max-w-[700px] lg:!w-[700px]"
    >
      <Tabs
        value={activeTab}
        onValueChange={onTabChange}
        className="w-full"
      >
        <TabsList className="gap-x-4 bg-transparent">
          {occupantsTabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="data-[state=active]:shadow-none hover:cursor-pointer text-gray-400 hover:text-primary px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={CURRENT}>
          <DataTable
            data={selectedRow?.occupants || []}
            columns={columns}
            className="shadow-none border-0"
            tableWrapperClassName="p-0"
            hideFooter
          />
        </TabsContent>
        <TabsContent value={HISTORY}>
          {isLoading ? <Loader /> :
            <DataTable
              data={usersGridData?.data?.sort((a: any, b: any) =>
                b.active - a.active
              ) || []}
              columns={columns}
              className="shadow-none border-0"
              tableWrapperClassName="p-0"
              hideFooter
            />
          }
        </TabsContent>
      </Tabs>
    </Dialog>
  )
}

export default OccupantsDialog;